import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=237566c0&scoped=true&"
import script from "./shopDetails.vue?vue&type=script&lang=js&"
export * from "./shopDetails.vue?vue&type=script&lang=js&"
import style0 from "./shopDetails.vue?vue&type=style&index=0&id=237566c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237566c0",
  null
  
)

export default component.exports